import type { ReceiptTemplate } from '../schema';

export const cynibelSupermarketTemplate: ReceiptTemplate = {
  id: 'cynibel-supermarket',
  name: 'Cynibel Supermarket Receipt',
  brand: 'CYNIBEL SUPERMARKET',
  description: 'Cynibel Supermarket receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'cyn-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'CYNIBEL SUPERMARKET',
        businessNameFontSize: 14,
        addressLines: ['1200 DARK AVENUE', 'MONSTERVILLE, CA 94608', '(510) 555-0127'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'cyn-datetime',
      type: 'datetime',
      enabled: true,
      config: { alignment: 'center', dateTime: new Date().toISOString(), format: 'MM/DD/YYYY hh:mm A', showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'cyn-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'MILK 2% GALLON', quantity: '1', price: '4.99', sku: '' },
          { id: '2', name: 'BREAD WHEAT', quantity: '1', price: '3.49', sku: '' },
          { id: '3', name: 'EGGS LARGE DZ', quantity: '1', price: '5.99', sku: '' },
          { id: '4', name: 'BANANAS', quantity: '1', price: '1.29', sku: '' },
          { id: '5', name: 'CHICKEN BREAST', quantity: '1', price: '8.99', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'cyn-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '24.75', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '2.04', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '26.79', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'cyn-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'cyn-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'THANK YOU FOR SHOPPING', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

